import ServiceStore from "stores/ServiceStore";
import { RouteType } from "types/RouteType";

const BomExtractionRoute: RouteType = {
  name: "Bom Extraction Tool",
  path: "/bom-extraction",
  layout: "/app",
  viewportCard: {
    header: {
      component: () => import("./BomExtractionHeader"),
      title: "BOM Extraction",
      enableRefreshButton: true,
    },
    body: {
      component: () => import("./BomExtractionBody"),
      grayBackground: true,
    },
  },
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  dialogs: [
    {
      name: "BomExtractionUpload",
      component: () => import("./dialogs/BomExtractionUploadDialog"),
      title: "Upload Document for BOM Extraction",
      cancelButton: true,
      height: 600,
      onSubmit: async (rootStore: any) => {
        const viewStore = rootStore.bomExtractionViewStore;
        if (
          !viewStore ||
          !viewStore.uploadingFiles ||
          viewStore.uploadingFiles.length === 0
        ) {
          return false;
        }

        try {
          await viewStore.uploadAndExtract();
          rootStore.routerStore.closeDialog();
          return true;
        } catch (error) {
          console.error("Upload failed:", error);
          return false;
        }
      },
      onSubmitValidation: (rootStore: any) => {
        const viewStore = rootStore.bomExtractionViewStore;
        return (
          viewStore &&
          viewStore.uploadingFiles &&
          viewStore.uploadingFiles.length > 0
        );
      },
    },
    {
      name: "BomExtractionViewer",
      component: () => import("./dialogs/BomExtractionViewer"),
      title: "BOM Document Viewer",
      cancelButton: false,
      height: 660,
      fullWidth: true,
    },
    {
      name: "BomExportDialog",
      component: () => import("./dialogs/BomExportDialog"),
      title: "Export BOM Data",
      cancelButton: true,
      height: 400,
      onSubmit: async (rootStore: any) => {
        const viewStore = rootStore.bomExtractionViewStore;
        await viewStore.exportBom();
        return true;
      },
    },
  ],
  beforeEnter: async ({ rootStore }: any) => {
    try {
      const bomExtractionStore = rootStore.bomExtractionStore as ServiceStore;
      const viewStore = rootStore.bomExtractionViewStore;

      // Check if the service store exists before trying to use it
      if (bomExtractionStore) {
        try {
          // Load initial BOM extraction history with a safe query
          // Don't use pagination methods if not enabled
          await bomExtractionStore.find();
          console.log("[BOM Route] Service loaded successfully");
          console.log(
            "current bom store entities:",
            bomExtractionStore.entities
          );
        } catch (error: unknown) {
          const err = error as { code?: number; message?: string };
          console.warn("[BOM Route] Service find failed:", err.message);
          // If service not found, enable demo mode
          if (
            err.code === 404 ||
            err.message?.includes("Service") ||
            err.message?.includes("No record found")
          ) {
            console.log(
              "[BOM Route] Service not configured on backend, enabling demo mode"
            );
            if (viewStore) {
              viewStore.enableDemoMode();
            }
          }
          // Continue anyway - the UI will work without data or in demo mode
        }
      } else {
        console.warn(
          "[BOM Route] BOM extraction store not initialized - backend service may not be available"
        );
        // Enable demo mode if viewStore exists
        if (viewStore) {
          console.log(
            "[BOM Route] Enabling demo mode due to missing service store"
          );
          viewStore.enableDemoMode();
        }
      }

      return true;
    } catch (error) {
      console.error("[BOM Route] Error in route setup:", error);
      // Always return true to allow navigation to continue
      return true;
    }
  },
  // onExit: ({ rootStore }: any) => {
  //   // Clean up ViewStore state
  //   const viewStore = rootStore.bomExtractionViewStore;
  //   viewStore.cleanup();
  // },
};

export default BomExtractionRoute;
